<template>
  <div class="home">
    <div id="top" class="row">
      <div id="welcome" class="col-sm-8">
        <h1>Bem-Vindo {{ name }}!</h1>
        <h4>{{ dayWeek }}, {{ day }} {{ month }} {{ year }}</h4>
      </div>

      <div class="col-sm-4" id="weather">
        <img v-bind:src="this.weather[2]" alt="" />
        <h2 id="city">{{ this.weather[0] }}</h2>
        <h3 id="temp">{{ this.weather[1] }} ºC</h3>
      </div>
    </div>
    <div id="add" class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Adicionar emprego</h5>
            <p class="card-text">
              Aqui pode criar uma nova oportunidade de emprego
            </p>
            <a href="#" class="btn btn-primary"
              ><router-link to="jobs"> Criar Emprego </router-link></a
            >
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Adicionar Competências</h5>
            <p class="card-text">
              Aqui pode adicionar mais competências ou remover
            </p>
            <a href="#" class="btn btn-primary"
              ><router-link to="skills">Competências</router-link></a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Adicionar Conteúdo</h5>
            <p class="card-text">
              Aqui pode adicionar conteúdo ao website da NEARCODE
            </p>
            <a href="#" class="btn btn-primary"
              ><router-link to="content">Criar Conteudo</router-link></a
            >
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <span v-if="type == 1">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Registar Utilizador</h5>
              <p class="card-text">
                Criar utilizador para poder aceder ao BackOffice
              </p>
              <a href="#" class="btn btn-primary"
                ><router-link to="register"> Criar Utilizador</router-link></a
              >
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: function() {
    return {
      weather: [],
      pages: [],
      name: this.$store.state.loggedUser.name,
      dayWeek: "",
      day: "",
      month: "",
      year: "",
      allMonths: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outobro",
        "Novembro",
        "Dezembro",
      ],
      type: "",
    };
  },
  created() {
    this.getDay();
    this.myWeather();
    this.getUser();
    this.getPage();
  },
  methods: {
    getDay() {
      let date = new Date();
      let weekDay = date.getDay();
      this.day = date.getDate();
      let mon = date.getMonth();
      this.year = date.getFullYear();
      switch (weekDay) {
        case 1:
          this.dayWeek = "Segunda-Feira";
          break;
        case 2:
          this.dayWeek = "Terça-Feira";
          break;
        case 3:
          this.dayWeek = "Quarta-Feira";
          break;
        case 4:
          this.dayWeek = "Quinta-Feira";
          break;
        case 5:
          this.dayWeek = "Sexta-Feira";
          break;
        case 6:
          this.dayWeek = "Sábado";
          break;
        case 7:
          this.dayWeek = "Domingo";
          break;
      }
      this.month = this.allMonths[mon];
    },
    async myWeather() {
      const res = await fetch(
        "https://api.openweathermap.org/data/2.5/weather?q=Porto&appid=ee5b838aaeaf6c10ac0ace722104dd82"
      );
      const data = await res.json();
      this.weather.push(
        data.name,
        (Number(data.main.temp) - 273.15).toFixed(1),
        "http://openweathermap.org/img/wn/" + data.weather[0].icon + "@2x.png"
      );
    },
    getUser() {
      this.name = this.$store.getters.getName;
      this.type = this.$store.getters.getType;
    },
    async getPage() {
      try {
        await this.$store.dispatch("fetchPages");
        this.pages = this.getPages;
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getWeather"]),
    ...mapGetters(["getName"]),
    ...mapGetters(["getPages"]),
  },
};
</script>

<style scoped>
.col-sm-6 {
  text-align: center;
}
#top {
  background: #f7951ea8;
  padding-bottom: 40px;
  padding-top: 20px;
  border-radius: 10px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
}
a {
  color: white;
  text-decoration: none;
}
.col-sm-6 {
  padding: 20px;
}
.home {
  padding: 50px 60px 0px 300px;
  text-align: left;
}
.card {
  background: #f5f7fa;
  box-shadow: 0 6px 10px #f7951ea8, 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  border: none;
}
.card:hover {
  transform: scale(1.05);
}
#add {
  margin-top: 50px;
}
#weather {
  padding-left: 80px;
  text-align: center;
  border-radius: 10px;
}
#welcome {
  margin-top: 70px;
}
#welcome h1,
h4 {
  padding-left: 50px;
  color: rgb(82, 82, 82);
}
a:hover {
  color: white;
  text-decoration: none;
}
</style>
